define('ajax-loader',['lib/event-emitter', 'session'], function (EventEmitter, session) {
	var loader = new EventEmitter();
	loader.title = document.title;
	var isEnabled = window.history && window.history.pushState;

	// work around chrome bug http://code.google.com/p/chromium/issues/detail?id=239907
	// shows resubmission warning on F5 after pushState when initial request is POST
	if (window.requestMethod != 'GET')
		isEnabled = false;

	if (!isEnabled) {
		loader.navigateTo = function (url) {
			location.href = url;
		};
	} else {
		var isAnythingPushed = false;
		var initialURL = location.href;
		var currentRequest = null;
		var currentRequestURL = null;

		var spinningWheelIframe = null;

		function startSpinningWheel() {
			if (!spinningWheelIframe) {
				spinningWheelIframe = $('<iframe>').hide().appendTo('body')[0];
				spinningWheelIframe.contentDocument.open();
			}
		}

		function stopSpinningWheel() {
			if (spinningWheelIframe) {
				spinningWheelIframe.contentDocument.close();
				$(spinningWheelIframe).remove();
				spinningWheelIframe = null;
			}
		}

		loader.navigateTo = function (url, disablePush) {
			var eventArgs = new EventArgs();
			loader.emit("beforeunload", eventArgs);
			if (eventArgs.cancelLoading) {
				var discardChanges = confirm(eventArgs.confirmationMessage);
				if (!discardChanges) {
					return;
				}
			}

			var urlAndHash = url.split('#');
			if (urlAndHash.length > 1) {
				var urlWithoutHash = urlAndHash[0];
				var hash = urlAndHash[1];
			} else {
				var hash = '';
				var urlWithoutHash = url;
			}
			var ajaxURL = urlWithoutHash +
				((urlWithoutHash.indexOf('?') >= 0) ? '&' : '?') + '_ajax';

			if (currentRequest) {
				if (currentRequestURL == ajaxURL)
					return; // already loading
				else
					currentRequest.abort();
			}

			currentRequestURL = ajaxURL;
			startSpinningWheel();
			currentRequest = $.ajax({
				url: ajaxURL,
				dataType: 'text'
			}).done(function (text) {
				var html = $(text);
				var title = html.find('#title').text();
				var body = html.find('#body');
				var pageID = html.find('#page-id').text();
				var finalURL = html.find('#url').text(); // url after redirections
				var bodyClass = html.find('#body-class').text();

				loader.emit('loading', pageID);

				$('#content').html(body.html());
				$('body').attr('data-page', pageID);
				if ($('body').attr('class') != bodyClass) {
					$('body').attr('class', bodyClass).trigger('class-change');
				}
				if (html.find('#request-statistics').length) {
					$('#request-statistics').html(html.find('#request-statistics').html());
				}

				if (title != '')
					document.title = title + ' - ' + 'WissenA5';
				else
					document.title = 'WissenA5';
				loader.title = document.title;

				// location API
				if (location.href != url && !disablePush) {
					history.pushState(null, null, finalURL + (hash ? '#' + hash : ''));
					isAnythingPushed = true;
				}

				if (!hash)
					window.scrollTo(0, 0);

				// go to hash
				if (hash) {
					location.hash = '#' + hash;
					var element = document.getElementById(hash);
					if (element && element.scrollIntoView)
						element.scrollIntoView();
				}

				//close header dropdown boxes
				$('#header').find('.dropdown-box').removeClass('open');
				$('#header').find('.dropdown-button').removeClass('active');

				// check if session has changed
				session.updateSessionData(JSON.parse(html.find('#session-info').text()));

				loader.emit('loaded', pageID);
			}).fail(function () {
				location.href = url;
			}).always(function () {
				stopSpinningWheel();
				currentRequest = null;
				currentRequestURL = null;
			});
		};

		window.addEventListener("popstate", function (e) {
			// TODO: navigating completely back in chrome will cause this
			if (location.href != initialURL) {
				isAnythingPushed = true;
			}

			// do not process "popstate" event if fired directly after page load (sent e.g. by chrome)
			if (!isAnythingPushed) {
				return;
			}

			loader.navigateTo(location.href, true /* disable push */);
		});
	}

	window.addEventListener("beforeunload", function (e) {
		var eventArgs = new EventArgs();
		loader.emit("beforeunload", eventArgs);
		if (eventArgs.cancelLoading) {
			e.returnValue = eventArgs.confirmationMessage;
		}
	});

	function EventArgs(message) {
		this.cancelLoading = false;
		this.confirmationMessage = message || "Aktuelle Seite verlassen?";
	}

	return loader;
});

